import React, { useState, useContext, useEffect } from "react";
import StepperNavigationButtons from "../../StepperNavigationButtons/StepperNavigationButtons";
import { EWContext } from "../../../context/EWContext";
import FormBuilder from "../FormBuilder/FormBuilder";
import { getFormAnswers, findElementIntoArray, getAnswersFromInitialValues } from "../../../utils/utils";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";

function PayeeForm(props) {
  const [accountState, setAccountState] = useContext(EWContext);
  const {
    version,
    customErrors,
    questions: {
      payee: questions
    },
    answers: {
      validate: userInfoAnswers,
      payee: answers,
    },
    customer,
    previousPayeeInformation,
    receiverRebateOptions,
    behaviors,
    persistPayeeInformation
  } = accountState;

  const disableAutofillPayee = useState(behaviors?.disable_payee_autofill || false)[0];
  const previousPayeeAnswers = [...previousPayeeInformation] || [];
  const accountDetailsAnswers = useState(questions.map(element => {
    const newAnswer = {
      "id": "rebateReceiver",
      "label": "Who is receiving the rebate?",
      "name": "rebateReceiver",
      "group": "payee",
      "position": 1,
      "type": "select",
      "required": true,
      "value": "AH",
      "textValue": "Account Holder",
      "extraValues": {},
      "summaryLabel": "Type"
    }
    const findedAnswer = { ...findElementIntoArray(userInfoAnswers, "id", `${element.id}`) || newAnswer };
    findedAnswer.group = "payee";
    return findedAnswer;
  }))[0];

  const disabledFields = ["firstName", "lastName"];
  let disabledInitialValues = {}
  persistPayeeInformation.forEach(element => {
    disabledInitialValues = { ...disabledInitialValues, [element.id]: true }
  });

  const [loading, setLoading] = useState(false);
  const [errorFields, setErrorFields] = useState(true);
  const [isValidForm, setIsValidForm] = useState(false);
  const [payeeFormAnswers, setPayeeFormAnswers] = useState(answers);
  const [rebateReceiver, setRebateReceiver] = useState({});
  const [disableState, setDisableState] = useState(disabledInitialValues || {});
  const [errorInForm, setErrorInForm] = useState({
    message: customErrors.genericError,
    genericMessage: customErrors.contactError,
    labelButton: "Back",
    error: false
  });
  const [formBehaviors, setFormBehaviors] = useState(behaviors);
  const { group, handleNext, handleBack } = props;
  const { groupName: portalType, hasPayee } = customer;

  const disableFields = (formRebateReceiver) => {
    let fieldFillAnswers = [];
    if (formRebateReceiver === "Trade Ally") {
      fieldFillAnswers = previousPayeeAnswers.length > 0 ? [...previousPayeeAnswers] : [];
    } else if (formRebateReceiver === "Account Holder") {
      fieldFillAnswers = accountDetailsAnswers.length > 0 ? [...accountDetailsAnswers] : [];
    } else {
      fieldFillAnswers = [];
    }

    fieldFillAnswers.length > 0
      ? fieldFillAnswers.map(answer => {
        return answer.value && disabledFields.includes(answer.id)
          ? setDisableState(prevState => { return { ...prevState, [answer.id]: formBehaviors?.disable_payee_fields || false } })
          : setDisableState(prevState => { return { ...prevState, [answer.id]: false } });
      })
      : setDisableState({});
  }

  useEffect(() => {
    if (persistPayeeInformation.length > 0) {
      const newFormValues = getAnswersFromInitialValues(questions, version, persistPayeeInformation);
      setPayeeFormAnswers(newFormValues);
    } else {
      const initialAnswers = answers.every(answer => Object.keys(answer).length !== 0);
      const rebateReceiverAnswer = answers.filter(answer => answer.id === "rebateReceiver")[0];
      if (initialAnswers && rebateReceiverAnswer) {
        disableFields(rebateReceiverAnswer.textValue);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setFormBehaviors(behaviors);
  }, [behaviors]);

  useEffect(() => {
    if ((hasPayee === "1" || hasPayee === 1) && (portalType && rebateReceiver.textValue) === "Trade Ally") {
      disableFields(rebateReceiver.textValue);
      if (disableAutofillPayee) {
        clearFields();
        setDisableState({});
      } else {
        if (previousPayeeAnswers.length > 0) {
          const newFormValues = getAnswersFromInitialValues(questions, version, previousPayeeAnswers);
          setPayeeFormAnswers(newFormValues);
        } else {
          clearFields();
        }
      }
    }
    if (rebateReceiver.textValue === "Account Holder") {
      disableFields(rebateReceiver.textValue);
      const newFormValues = getAnswersFromInitialValues(questions, version, accountDetailsAnswers);
      setPayeeFormAnswers(newFormValues);
    }
    if (rebateReceiver.textValue === "Tenant" || rebateReceiver.textValue === "Landlord") {
      clearFields();
      setDisableState({});
    }
    // eslint-disable-next-line
  }, [rebateReceiver]);

  useEffect(() => {
    if (payeeFormAnswers.length > 0) {
      const formIsAnswered = payeeFormAnswers.every((field) => {
        if(field.type === "date") {
          if(field.value == "Invalid Date") {
            return false
          }
          let dateRange =  questions.find(ques => ques.id === field.id).field.rangeDates;

          if(dateRange?.minDate?.date) {

            if(new Date(field.value ) < new Date(dateRange.minDate.date)){
              return false
            }
          } 

          if(dateRange?.maxDate?.date) {
            if(new Date(field.value) > new Date(dateRange.maxDate.date)) {
              return false
            }
          }
        }
        return field ? (field.required ? field.value !== "" : true) : false
      });
      
      if (formIsAnswered) {
        setErrorFields(false);
      } else {
        setErrorFields(true);
      }
    } else {
      setErrorFields(true);
    }
    // eslint-disable-next-line
  }, [payeeFormAnswers]);

  useEffect(() => {
    if (isValidForm) {
      // Saving answers in the App state
      setAccountState((prevAccountState) => ({
        ...prevAccountState,
        answers: {
          ...prevAccountState.answers,
          payee: [...payeeFormAnswers]
        },
        submitAttempts: 0
      }));
      setLoading(false);
      handleNext(true);
    }
  }, [
    isValidForm,
    payeeFormAnswers,
    setAccountState,
    handleNext
  ]);

  useEffect(() => {
    if (errorInForm.error) {
      setAccountState((prevAccountState) => ({
        ...prevAccountState,
        submitAttempts: prevAccountState.submitAttempts + 1,
        eligibilityError: errorInForm,
      }));
    }
  }, [errorInForm, setAccountState]);

  const clearFields = () => {
    const myObj = [...accountDetailsAnswers];
    const newFormAnswers = getFormAnswers(myObj, questions);
    const newBlankAnswers = newFormAnswers.map(element => {
      let anserNew = { ...element };
      if (anserNew.id !== "rebateReceiver") {
        anserNew.value = "";
        anserNew.textValue = "";
      } else {
        anserNew.value = rebateReceiver.value;
        anserNew.textValue = rebateReceiver.textValue;
      }
      return anserNew;
    });
    setPayeeFormAnswers(newBlankAnswers);
  }

  const handleOnFormAnswered = (newAnswers, lastFieldModified) => {
    if (lastFieldModified?.id === "rebateReceiver") {
      setRebateReceiver(newAnswers.rebateReceiver);
    }
    const formAnswers = getFormAnswers(newAnswers, questions);
    const formIsAnswered = formAnswers.every(
      (field) => {
        return field.required ? field.value !== "" : true;
      }
    );
    if (formIsAnswered) {
      setErrorFields(false);
      setPayeeFormAnswers(formAnswers);
      setAccountState((prevAccountState) => ({
        ...prevAccountState,
        answers: {
          ...prevAccountState.answers,
          payee: [...formAnswers]
        }
      }));
    } else {
      setErrorFields(true);
    }
  };

  const handleSubmit = async (evt) => {
    setLoading(true);
    evt.preventDefault();
    try {
      setIsValidForm(true);
    } catch (error) {
      setIsValidForm(false);
      displayError(error)
    }
  };

  const displayError = (error, secondaryMessage) => {
    const errorMessage = error?.message || error;
    setLoading(false);
    if (error) {
      setErrorInForm(prev => {
        return {
          ...prev,
          ...{
            message: errorMessage || customErrors.genericError,
            genericMessage: secondaryMessage || '',
            error: true
          }
        }
      })
    }
  };

  return (
    <FormBuilder
      questions={questions}
      answers={payeeFormAnswers}
      onFormAnswered={handleOnFormAnswered}
      handleSubmit={handleSubmit}
      formInstructions={group.instructions}
      extraInfoAfterRequired={group.extraInfoAfterRequired}
      requiredFieldsSubtitule={true}
      customConfig={{
        hasValues: previousPayeeAnswers.length > 0,
        dropdownOptions: {
          "rebateReceiver": receiverRebateOptions
        },
        disableFields: disableState
      }}
    >
      <StepperNavigationButtons
        handleBack={handleBack}
        handleNext={() => null}
        loading={loading}
        nextButtonDisabled={errorFields}
      />
    </FormBuilder>
  );
}

export default withErrorHandler(PayeeForm);
